import { Pipe, PipeTransform } from '@angular/core';
import { DeviceStaticDataService } from '@shared/services/device-static-data.service';

@Pipe({
  name: 'deviceState',
})
export class DeviceStatePipe implements PipeTransform {
  constructor(private deviceStaticDataService: DeviceStaticDataService) {}

  transform(state: string): string {
    return this.deviceStaticDataService.states[state] || state;
  }
}
